"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GridBasicExample = void 0;
var tslib_1 = require("tslib");
var mithril_1 = tslib_1.__importDefault(require("mithril"));
var _1 = require("@/");
var examples_1 = require("@shared/examples");
var EXAMPLE_SRC = 'components/grid/examples/basic.ts';
var GridBasicExample = /** @class */ (function () {
    function GridBasicExample() {
        this.gutter = false;
    }
    GridBasicExample.prototype.view = function () {
        var gridAttrs = {
            gutter: this.gutter ? 20 : 0,
            align: this.align,
            justify: this.justify
        };
        var exampleAttrs = {
            class: 'cui-example-grid',
            options: this.renderOptions(),
            center: false,
            src: EXAMPLE_SRC
        };
        return (0, mithril_1.default)(examples_1.Example, exampleAttrs, [
            (0, mithril_1.default)(_1.Grid, tslib_1.__assign({}, gridAttrs), [
                (0, mithril_1.default)(_1.Col, { span: 8 }, (0, mithril_1.default)('.cui-example-grid-col', 'col-8')),
                (0, mithril_1.default)(_1.Col, { span: 4 }, (0, mithril_1.default)('.cui-example-grid-col', 'col-4'))
            ]),
            (0, mithril_1.default)(_1.Grid, tslib_1.__assign({}, gridAttrs), [
                (0, mithril_1.default)(_1.Col, { span: 4 }, (0, mithril_1.default)('.cui-example-grid-col', 'col-4')),
                (0, mithril_1.default)(_1.Col, { span: 4 }, (0, mithril_1.default)('.cui-example-grid-col[style=height:100px]', 'col-4')),
                (0, mithril_1.default)(_1.Col, { span: 3 }, (0, mithril_1.default)('.cui-example-grid-col', 'col-3'))
            ])
        ]);
    };
    GridBasicExample.prototype.renderOptions = function () {
        var _this = this;
        return [
            (0, mithril_1.default)('h5', 'Align'),
            (0, mithril_1.default)(_1.Select, {
                options: ['top', 'middle', 'bottom'],
                onchange: function (e) { return _this.align = e.target.value; },
                size: 'xs'
            }),
            (0, mithril_1.default)('h5', 'Justify'),
            (0, mithril_1.default)(_1.Select, {
                options: ['start', 'center', 'space-around', 'space-between'],
                onchange: function (e) { return _this.justify = e.target.value; },
                size: 'xs'
            }),
            (0, mithril_1.default)(_1.Switch, {
                checked: this.gutter,
                label: 'Gutter',
                onchange: function () { return _this.gutter = !_this.gutter; }
            })
        ];
    };
    return GridBasicExample;
}());
exports.GridBasicExample = GridBasicExample;
